import { createContext, useContext, useState } from "react";
import { DateTime } from "luxon";

const NotificationsContext = createContext();

export function NotificationsProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (reservation) => {
    const dateInSaoPaulo = DateTime.fromJSDate(
      new Date(reservation.reservationDate)
    )
      .setZone("America/Sao_Paulo")
      .toFormat("dd/MM/yyyy");

    const newNotification = {
      message: `Escola ${reservation.schoolName} liberada para a data ${dateInSaoPaulo}`,
      data: reservation,
    };

    setNotifications((prev) => [...prev, newNotification]);
  };

  const clearNotifications = () => {
    setNotifications([]);
  };

  return (
    <NotificationsContext.Provider
      value={{ notifications, setNotifications, addNotification, clearNotifications }}
    >
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotifications() {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error(
      "useNotifications must be used within a NotificationsProvider"
    );
  }
  return context;
}
